import React from 'react';
import './ForgotUserName.scss';
import Grid from "@mui/material/Grid";

const ForgotUserName = () => {

    const userNameUrl = 'http://www.greateratlantic.fisheries.noaa.gov/apps/login/forgot_username';

    return (
        <div>
            <h3 className="sectionTitle center">Forgot User Name</h3>
            <Grid container justifyContent="center" alignItems="center" spacing={2}>
                <Grid item xs={12} lg={6} style={{ wordBreak: "break-word"}}>
                    Username retrieval is currently available if you have previously registered an email address with NMFS. You can retrieve your username via the web here:
                    <a href={userNameUrl}  target={"_blank"} rel="noopener noreferrer"> {userNameUrl}</a>
                </Grid>
                <Grid item xs={12}>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={6}>
                For assistance, please call <a href="tel:978-281-9188">(978) 281-9188</a>.
            </Grid>
        </div>
    );
}

export default ForgotUserName;
